import React, { useCallback, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Intl, ModalForm } from 'components';
import CampaignService from 'api/Campaign';
import SettingsActions from 'store/reducers/Settings';
import { handlePromise } from 'utils';
import MultipleUpload from '../Multiple';
import SingleUpload from '../Single';

const UploadModal = ( {
  campaignId, open, values, onClose, onSubmit, toggleLoading,
} ) => {
  const [submitErrors, setSubmitErrors] = useState( null );
  const modalFormRef = useRef( null );

  const uploadFile = useCallback( async ( field, dataToSend ) => {
    toggleLoading( true );
    const [errors, response, responseData] = await handlePromise(
      CampaignService.saveWizardCampaignMedia( campaignId, dataToSend ),
    );
    toggleLoading( false );

    if ( !response.ok ) {
      modalFormRef.current.reset();
      return setSubmitErrors( _.isObject( errors )
        ? _.join( _.map( errors, ( error, key ) => `${key}: ${error}` ), '<br/>' ) : errors );
    }
    setSubmitErrors( null );
    modalFormRef.current.change( field, {
      id: responseData.id,
      uri: responseData.uri,
      originalName: responseData.originalName,
      time: responseData.time,
    } );
  }, [campaignId, toggleLoading] );

  return (
    <ModalForm
      title={`${values.messageType}_${values.audioSource}`}
      showErrorsInHeader
      size="lg"
      open={open}
      bodyClassName="campaign-wizard-upload-file-modal"
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={values}
      validate={( formValues ) => {
        const errors = {};
        if ( values.messageType === 'poll' && ( !formValues.introductionFile || !formValues.optionsFile || !formValues.farewellFile ) ) {
          errors.files = true;
        }
        return errors;
      }}
      body={( modalForm ) => {
        modalFormRef.current = modalForm;
        const modalState = modalForm.getState();
        return (
          <>
            {values.messageType === 'poll' && (
              <MultipleUpload
                values={modalState.values}
                submitErrors={submitErrors}
                onUpload={uploadFile}
              />
            )}
            {values.messageType === 'simple_message' && (
              <SingleUpload
                field="singleFile"
                submitErrors={submitErrors}
                onUpload={uploadFile}
              />
            )}
            {values.messageType === 'poll' && modalState.submitFailed && modalState.errors.files
            && <div className="error mt-1 text-md text-center"><Intl id="campaignThreeAudioError" /></div>}
            {values.messageType === 'simple_message' && modalState.submitFailed && modalState.errors.singleFile
            && <div className="error mt-1 text-md text-center"><Intl id="campaignOneAudioError" /></div>}
          </>
        );
      }}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
        >
          <Intl id="save" />
        </Button>
      )}
    />
  );
};

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( UploadModal );
